function PowerIcon() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable={false}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 0C5.37271 0 0.00012207 5.37258 0.00012207 12V44C0.00012207 50.6274 5.37271 56 12.0001 56H44.0001C50.6275 56 56.0001 50.6274 56.0001 44V12C56.0001 5.37258 50.6275 0 44.0001 0H12.0001ZM26 23.4161V5.41424C26 4.52333 27.0772 4.07716 27.7071 4.70713L30.671 7.67104C32.1216 9.1216 32.7305 11.2127 32.2855 13.2153L30.017 23.4235C31.7738 24.1989 33 25.9563 33 28C33 28.1892 32.9895 28.3758 32.9691 28.5595L48.5599 37.5609C49.3314 38.0063 49.1792 39.1622 48.3187 39.3928L44.2699 40.4777C42.2884 41.0086 40.173 40.4904 38.6612 39.1037L30.9542 32.0344C30.1265 32.6415 29.1051 33 28 33C26.8883 33 25.8614 32.6372 25.0311 32.0235L9.44015 41.025C8.66861 41.4704 7.74364 40.7607 7.97423 39.9001L9.05909 35.8513C9.59004 33.8698 11.0965 32.2969 13.0533 31.6811L23.029 28.5412C23.0098 28.3635 23 28.1829 23 28C23 25.9497 24.2341 24.1876 26 23.4161ZM30.1741 34.6559C29.4897 34.8793 28.759 35.0001 28 35.0001C27.241 35.0001 26.5103 34.8793 25.8259 34.6559L25.0499 50.9525C25.0227 51.5228 25.4778 52.0001 26.0488 52.0001H29.9513C30.5222 52.0001 30.9773 51.5228 30.9501 50.9525L30.1741 34.6559ZM30.5 28C30.5 29.3807 29.3807 30.5 28 30.5C26.6193 30.5 25.5 29.3807 25.5 28C25.5 26.6193 26.6193 25.5 28 25.5C29.3807 25.5 30.5 26.6193 30.5 28Z"
      />
    </svg>
  );
}

export default PowerIcon;
